import React from 'react'
import Layout from '../../../../common/layout'
import { useSelector } from 'react-redux';
import userImage from "../../../../common/assets/images/user-icon.svg";

const SingleUserProfile = () => {
  const userProfileData = useSelector((store) => store.singleUserProfile.data);

  const InfoRow = ({ label, value }) => (
    <div className="flex flex-col md:flex-row md:gap-10 mb-4">
      <h2 className="font-medium md:w-1/3">{label}</h2>
      <p className="md:w-2/3 break-words">{value}</p>
    </div>
  );

  return (
    <Layout>
      <div>
        <div className="flex justify-between my-3">
          <h1 className="capitalize font-semibold text-2xl md:text-3xl">Profile</h1>
        </div>

        <div className="bg-white mt-2 p-5 rounded shadow-sm">
          <img
            src={userProfileData.image || userImage}
            alt="avatar"
            className="w-28 h-28 object-cover border border-dashed p-1 mb-5 rounded-full"
          />

          <InfoRow label="Name" value={userProfileData.name} />
          <InfoRow label="Email" value={userProfileData.email} />
          <InfoRow label="Age" value={userProfileData.ageRange} />
          <InfoRow label="Role" value={userProfileData.role?.toLowerCase() || '-'} />
          <InfoRow label="Mobile No." value={userProfileData.mobile || "-"} />
          <InfoRow label="Media Platforms" value={userProfileData.mediaName || "-"} />
          <InfoRow label="Associated Website" value={userProfileData.affiliateWithOtherSites || "-"} />
          <InfoRow label="Niche" value={userProfileData.niche || '-'} />
          <InfoRow label="Status" value={userProfileData.status} />
          <InfoRow label="LinkedIn URL" value={userProfileData.linkedinUrl || "-"} />
          <InfoRow label="Facebook URL" value={userProfileData.facebookUrl || "-"} />
          <InfoRow label="Twitter URL" value={userProfileData.twitterUrl || "-"} />
          <InfoRow label="Instagram URL" value={userProfileData.instagramUrl || "-"} />
        </div>
      </div>
    </Layout>
  );
};

export default SingleUserProfile;
